declare global {
  interface Window {
    googleTranslateElementInit?: () => void;
    google?: {
      translate: {
        TranslateElement: new (options: { pageLanguage: string; autoDisplay: boolean }, id: string) => void;
      };
    };
  }
}

let loadPromise: Promise<void> | null = null;

const waitForTranslateCombo = async (): Promise<HTMLSelectElement | null> => {
  for (let attempt = 0; attempt < 30; attempt += 1) {
    const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
    if (select) {
      return select;
    }

    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => resolve());
    });
  }

  return null;
};

export const preloadGoogleTranslate = (): Promise<void> => loadGoogleTranslate();

export const loadGoogleTranslate = (): Promise<void> => {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const initTranslate = () => {
      try {
        if (!window.google?.translate) {
          reject(new Error('Google Translate is unavailable'));
          return;
        }

        if (!document.querySelector('.goog-te-combo')) {
          new window.google.translate.TranslateElement(
            { pageLanguage: 'en', autoDisplay: false },
            'google_translate_element',
          );
        }

        resolve();
      } catch (error) {
        reject(error);
      }
    };

    if (window.google?.translate) {
      initTranslate();
      return;
    }

    window.googleTranslateElementInit = initTranslate;

    const existingScript = document.querySelector<HTMLScriptElement>(
      'script[src*="translate.google.com/translate_a/element.js"]',
    );

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.onerror = () => reject(new Error('Failed to load Google Translate'));
      document.head.appendChild(script);
    }
  });

  return loadPromise;
};

export const changeGoogleTranslateLanguage = async (gtCode: string): Promise<void> => {
  await loadGoogleTranslate();
  const select = await waitForTranslateCombo();
  if (!select) {
    return;
  }

  select.value = gtCode;
  select.dispatchEvent(new Event('change'));
};
